import style from "./TrailsWrapper.module.scss";

export default function TabsComponent({ data, activeTab, setActiveTab, partnerTrailIds }) {

  return (
    <div className={`${style.tabContainer} mx-5`}>
      {data?.map((tab) => {
        const isPartner = partnerTrailIds.includes(tab.id);
        return (
          <div
            key={tab.id}
            className={`${style.tab} btn ${activeTab === tab.id ? `${style.active}` : ""} ${isPartner ? `${style.partnerTab}` : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.title}
          </div>
        );
      })}
    </div>
  );
}
